/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Carrier_Form_Customer_Service_UnavailableInputs */

const vi_carrier_form_customer_service_unavailable = /** @type {(inputs: Carrier_Form_Customer_Service_UnavailableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dịch vụ khách chọn (${i?.name}) không có trong báo giá — chọn dịch vụ khác và báo lại khách.`)
};

/**

* @param {Carrier_Form_Customer_Service_UnavailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_customer_service_unavailable = /** @type {((inputs: Carrier_Form_Customer_Service_UnavailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Customer_Service_UnavailableInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_customer_service_unavailable(inputs)
});